import {Component, inject} from '@angular/core';
import {appName, credits, currentYear} from '@/app/constants';
import {VersionService} from '@core/services/version.service';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.component.html'
})
export class FooterComponent {
  private versionService = inject(VersionService);

  currentYear = currentYear;
  appName = appName;
  credits = credits;
  version = this.versionService.getFullVersion();
  buildDate = this.versionService.getFormattedBuildDate();
}
